export default {"src":"/_next/static/media/petsitter.6cec2ec8.svg","height":329,"width":403,"blurWidth":0,"blurHeight":0};